import { render, staticRenderFns } from "./MontagemCargaChecaMdfeDetalhes.vue?vue&type=template&id=4685ce51"
import script from "./MontagemCargaChecaMdfeDetalhes.vue?vue&type=script&lang=js"
export * from "./MontagemCargaChecaMdfeDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports